import { render } from "./detail_2.vue?vue&type=template&id=edcbde3c"
import script from "./detail_2.vue?vue&type=script&lang=js"
export * from "./detail_2.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/oralhealthmap.uz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__